import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "4", y2: "20", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SplitSquareHorizontal";
const SplitSquareHorizontal = memo(themed(Icon));
export {
  SplitSquareHorizontal
};
//# sourceMappingURL=split-square-horizontal.js.map
